const COMPONENT_NAME = "parallax";
const CLASS_SELECTOR = ".Parallax";
const LAYER_SELECTOR = ".ParallaxLayer";

const instances = [];
let initialized = false;
let lastTimestamp = 0;

function inverseLerp(a, b, value) {
    if (a !== b) {
        return (value - a) / (b - a);
    }
    return 0;
}
function syncAll(timestamp) {
    if (lastTimestamp === timestamp) return;
    lastTimestamp = timestamp;
    instances.forEach((instance) => instance.sync());
}
function updateHandler() {
    window.requestAnimationFrame(syncAll);
}

function initialize(element, PageComponents) {
    const layerElements = element.querySelectorAll(LAYER_SELECTOR);
    const layers = [];
    layerElements.forEach((layer) => {
        const scale= parseFloat(layer.getAttribute("data-scale"));
        const alwaysActive= !!layer.getAttribute("data-always-active");
        layer.style.height = (100.0 * scale) + '%';
        layers.push({
            element: layer,
            scale,
            alwaysActive,
            padding: (scale - 1) / scale,
        });
    });

    function inView(rect) {
        return (rect.bottom > 0 || rect.top < window.innerHeight);
    }

    function sync() {
        const rect = element.getBoundingClientRect();
        if (inView(rect)) {
            layers.forEach((layer) => {
                if (layer.scale === 1) return;

                const range = rect.height + window.innerHeight;
                const progress = window.innerHeight - rect.top;
                const translate = layer.padding * progress / range;
                //const xOffset = ((rect.top - window.innerHeight) / rect.height);
                /*
                const ceil = -rect.height;
                //const floor = rect.bottom;
                const floor = window.innerHeight + rect.height;
                const fraction = 1.0 - inverseLerp(floor, ceil, rect.top);
                const percent = layer.padding * -fraction
                layer.element.style.transform = `translateY(${100.0 * percent}%)`;
                */
                layer.element.style.transform = `translateY(${100.0 * translate}%)`;
            });
        }
    }

    instances.push({
        layers,
        sync,
    });

    if (!initialized) {
        initialized = true;
        document.addEventListener("scroll", updateHandler);
        document.addEventListener("resize", updateHandler);
    }

    setTimeout(sync, 500);
}

module.exports = {
    name: COMPONENT_NAME,
    instances,
    initialize,
};
